import React from 'react';
import styled from 'styled-components';

import CTA from './CTA';
import Description from './Description';
import TitleRow from './TitleRow';

const Wrapper = styled.div`
  display: flex;
  font-family: 'OCRoboto';
  flex-direction: row;
  padding: 30px;
  gap: 46px;

  @media (max-width: 1199px) {
    flex-direction: column;
    padding: 0px;
  }
`;

const Column1 = styled.div`
  flex: 0.3;
  display: flex;
  text-align: left;
  flex-direction: column;
`;

const Column2 = styled.div`
  flex: 0.6;
  display: flex;
  justify-content: normal;
  align-items: normal;
  img {
    max-width: 100%;
    width: 767px;
    height: 500px;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  }
  @media (max-width: 1199px) {
    display: none;
  }
`;

const Row = styled.div`
  margin-bottom: 10px;
`;

const MobileImage = styled.div`
  display: none;
  @media (max-width: 1199px) {
    display: contents;
    height: auto;
    img {
      width: -webkit-fill-available;
    }
  }
`;

const OCLogo = styled.div`
  @media (max-width: 1199px) {
    display: none;
  }
`;

export default ({ downloadURL, title, ocLogoURL, widgetDescription, widgetImageURL }) => (
  <Wrapper>
    <Column1>
      <Row>
        <OCLogo>
          <img src={ocLogoURL} alt={title} width="50" />
        </OCLogo>
      </Row>
      <TitleRow title={title} ocLogoURL={ocLogoURL} />
      <Row>
        <MobileImage>
          <img src={widgetImageURL} alt="GO ROOF GAWKING™ FOR COLOR INSPIRATION!" />
        </MobileImage>
      </Row>
      <Row>
        <Description text={widgetDescription} />
      </Row>
      <Row>
        <CTA url={downloadURL} />
      </Row>
    </Column1>
    <Column2>
      <img src={widgetImageURL} alt="GO ROOF GAWKING™ FOR COLOR INSPIRATION!" />
    </Column2>
  </Wrapper>
);
